<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <span>Technology & Products</span>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 设计中心 -->
      <section id="sjzx">
        <div class="container gradient-background">
          <div class="row">
            <div class="col-lg-12 rzTop">
              <h1><span>Engineering & Design</span></h1>
              <p>
                Far East Group utilizes modern design concepts and adheres to
                relevant national standards for its engineering & design. The
                group features a design center and holds a Class A steel
                structure design certificate. It boasts a strong professional
                design team based in Hai'an and Kunshan in Jiangsu province.
                This team employs internationally advanced design software,
                including MBS, X-STEEL, PKPM, 3D3S, STAADPRO, MTS, and CFS,
                enabling them to handle all aspects of design from structural
                layout to manufacturing details.With over 4,000 design
                experiences in various fields, Far East Group provides
                comprehensive manufacturing and installation drawings for steel
                structures, ensuring that both manufacturing and construction
                processes are carried out accurately and efficiently.
              </p>
              <div class="container-fluid">
                <div
                  class="col-lg-6 col-xs-6"
                  v-for="(item, index) in sjzxList"
                  :key="index"
                >
                  <div class="sjzxImg">
                    <img :src="item.image" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 系统产品 -->
          <section id="xtcp">
            <div class="row">
              <div class="col-lg-12 xtTop">
                <h1><span>Far East Group System Products</span></h1>
              </div>
            </div>

            <div class="container-fluid">
              <div
                class="col-lg-6 col-xs-6"
                v-for="(item, index) in xtList"
                :key="index"
                @click="openModal(index)"
              >
                <div class="xtImg">
                  <img :src="item.image" alt="" />
                  <p class="xtp">{{ item.text }}</p>
                </div>
              </div>
            </div>
            <div v-if="isModalOpen" class="modal">
              <div class="modal-content">
                <span class="xmodaltop">System Products</span>
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal">&times;</span>
                <!-- 详细内容 -->
                <div class="xxd">
                  <el-carousel
                    :autoplay="false"
                    trigger="click"
                    indicator-position="outside"
                    :initial-index="this.selectedIndex"
                  >
                    <el-carousel-item
                      v-for="(item, index) in xtxqList"
                      :key="index"
                    >
                      <div class="col-lg-12 xxnrbor">
                        <div class="content">
                          <div class="img-container visible-lg">
                            <img :src="item.image" alt="Lazy-loaded Image" />
                          </div>
                          <div class="text-container col-xs-12">
                            <h3>{{ item.htext }}</h3>
                            <img
                              :src="item.image"
                              alt="Lazy-loaded Image"
                              class="hidden-lg"
                            />
                            <p style="white-space: pre-wrap">
                              {{ item.ptext }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </section>

          <!-- 华胤专利 -->
          <section id="hyzl">
            <div class="row">
              <div class="col-lg-12 rzTop">
                <h1><span>Far East Group Patents</span></h1>
                <p>
                  Far East specializes in the research and development of
                  factory construction technology. The company has received 12
                  patents for steel structures, including innovations such as
                  new tie rods, roof ventilation devices, and wind-resistant
                  sliding fixing seats for roof steel plates. These advancements
                  contribute to lower energy consumption in factories and
                  enhance their durability.
                </p>
              </div>
            </div>
            <div>
              <h2>
                <span class="hspan"
                  ><span style="color: red">///////// </span>Patent
                  Certificate</span
                >
              </h2>
            </div>
            <div class="container-fluid">
              <div
                class="col-lg-1-5 col-xs-4"
                v-for="(item, index) in jtzlList"
                :key="index"
              >
                <div class="portfolio-item">
                  <div class="thumb">
                    <div class="image">
                      <div class="demo-image__preview jtzlImg">
                        <el-image
                          style="height: 100%"
                          :src="item.image[0]"
                          :preview-src-list="item.image"
                        >
                        </el-image>
                      </div>
                    </div>
                    <div class="hover-effect">
                      <div
                        class="hover-content jtzlHeight"
                        style="white-space: pre-line"
                      >
                        <h1>{{ item.text }}</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- 安裝服務 -->
          <section id="azfw">
            <div class="row">
              <div class="col-lg-12 rzTop">
                <h1><span>Erection Service</span></h1>
                <p>
                  Far East Group has successfully completed over 4,000
                  engineering projects, gaining extensive experience in project
                  management. To enhance the efficiency of project management
                  and on-site services, the company has implemented a project
                  manager management system. The project manager maintains close
                  collaboration with the owner, design institute, supervisors,
                  relevant government departments, and other contractors to
                  ensure smooth project execution. Additionally, the company
                  offers excellent after-sales service, providing customers with
                  peace of mind and reinforcing our commitment to quality and
                  customer satisfaction.
                </p>
              </div>
              <div class="col-lg-12 azTop">
                <img
                  src="@/components/img/cpyfw/azfw.jpg"
                  alt=""
                  style="width: 85vw"
                />
              </div>
            </div>
          </section>

          <!-- 新能源 -->
          <section id="gsxny">
            <div class="row">
              <div class="col-lg-12 nyTop">
                <h1><span>Renewable Energy Business</span></h1>
                <p>
                  Far East Group has expanded its operations beyond steel
                  structure engineering into the renewable energy sector.<br />
                  By leveraging rooftop solar installations across its own
                  manufacturing facilities, the Group provides integrated
                  services covering development, engineering, construction, and
                  operation (EPC + O&M), ensuring stable and sustainable power
                  supply.<br />
                  The generated electricity is utilized for internal consumption
                  and also supplied to the power grid, supporting both
                  industrial energy demand and public infrastructure.<br />By
                  integrating its steel structure expertise, Far East delivers
                  rooftop, industrial, and plant-based solar solutions, helping
                  clients reduce energy costs and carbon emissions while
                  advancing sustainable development.
                </p>
              </div>
              <div class="col-lg-12">
                <div class="xnyNum">
                  <div class="xnytitle">
                    No.1<br />
                    Guosheng Solar Power Project<br />(Self-Owned Power Plant)
                  </div>
                  <div>
                    <carousel-3d
                      :controlsVisible="true"
                      :width="cWidth"
                      :height="cHeight"
                      :display="5"
                      :space="280"
                    >
                      <slide :index="0">
                        <img
                          v-lazy="hyxny1"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="1">
                        <img
                          v-lazy="hyxny2"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="2">
                        <img
                          v-lazy="hyxny3"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="3">
                        <img
                          v-lazy="hyxny4"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="4">
                        <img
                          v-lazy="hyxny5"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                    </carousel-3d>
                  </div>
                  <div class="xnyContent">
                    <p>
                      Guosheng Power Station is a rooftop solar power project
                      promoted by Far East, utilizing a high-efficiency
                      distributed solar power system (also known as a
                      photovoltaic power generation system), specifically
                      designed for industrial scenarios. <br />
                      The system is installed on factory rooftops, achieving
                      "local generation, local consumption," effectively
                      reducing power transmission losses and enhancing energy
                      use efficiency.<br />
                      Through high-efficiency solar modules, solar energy is
                      directly converted into electricity to support the daily
                      power needs of enterprises, while also implementing an
                      operating model of "self-generation and self-use, with
                      surplus electricity fed into the grid," creating
                      additional revenue while reducing electricity costs.
                    </p>
                  </div>
                </div>
                <div class="xnyNum">
                  <div class="xnytitle">
                    No.2<br />
                    Sensteel Factory Solar Power Project
                  </div>
                  <div>
                    <carousel-3d
                      :controlsVisible="true"
                      :width="cWidth"
                      :height="cHeight"
                      :display="5"
                      :space="280"
                    >
                      <slide :index="0">
                        <img
                          v-lazy="hyxny6"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="1">
                        <img
                          v-lazy="hyxny7"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="2">
                        <img
                          v-lazy="hyxny8"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="3">
                        <img
                          v-lazy="hyxny9"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="4">
                        <img
                          v-lazy="hyxny10"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                    </carousel-3d>
                  </div>
                  <div class="xnyContent">
                    <p>
                      Sengang Power Station is a large-scale rooftop solar power
                      project built by Far East, with a total installed capacity
                      of 2MW (2000kW). It is a high-efficiency distributed solar
                      power system, widely applied in industrial manufacturing
                      plants.<br />
                      This project is installed on the roof of Anhui Sengang
                      Assembly Manufacturing Co., Ltd., utilizing a color steel
                      tile roof structure. It is equipped with 3,478 pieces of
                      575Wp high-efficiency monocrystalline solar modules,
                      achieving a high-density power generation configuration
                      and maximizing the utilization efficiency of the roof
                      space.<br />
                      The system operates under a 'self-use, surplus electricity
                      fed into the grid' model and is connected to the plant's
                      power system through a 380V low-voltage grid system,
                      effectively reducing electricity costs for the enterprise
                      while enhancing energy autonomy.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
      <div class="mailbg">
        <to-mail buttonText="REQUEST A QUOTE"></to-mail>
      </div>
      <!-- 小滾輪 -->
      <div id="ss_menu">
        <div>
          <i><a @click="forId('sjzx')">Design</a></i>
        </div>
        <div>
          <i><a @click="forId('xtcp')">Products</a></i>
        </div>
        <div>
          <i><a @click="forId('hyzl')">Patents</a></i>
        </div>
        <div>
          <i><a @click="forId('azfw')">Erection</a></i>
        </div>
        <div>
          <i
            ><a @click="forId('gsxny')">Solar<br />Power</a></i
          >
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isModalOpen: false, // 控制模态框的显示状态
      selectedIndex: 0,
      sjzxList: [
        {
          image: require('@/components/img/cpyfw/sjzx1.png'),
        },
        {
          image: require('@/components/img/cpyfw/sjzx2.png'),
        },
        {
          image: require('@/components/img/cpyfw/sjzx3.png'),
        },
        {
          image: require('@/components/img/cpyfw/sjzx4.png'),
        },
      ],
      xtList: [
        {
          image: require('@/components/img/cpyfw/xtcp1.jpg'),
          text: 'Ventilation System',
        },
        {
          image: require('@/components/img/cpyfw/xtcp2.jpg'),
          text: 'Roof System',
        },
        {
          image: require('@/components/img/cpyfw/xtcp3.jpg'),
          text: 'Daylighting System',
        },
        {
          image: require('@/components/img/cpyfw/xtcp4.jpg'),
          text: 'Purlins Surround Beams',
        },
        {
          image: require('@/components/img/cpyfw/xtcp5.jpg'),
          text: 'Floor System',
        },
        {
          image: require('@/components/img/cpyfw/xtcp6.jpg'),
          text: 'Main Steel System',
        },
        {
          image: require('@/components/img/cpyfw/xtcp7.jpg'),
          text: 'Wall System',
        },
        {
          image: require('@/components/img/cpyfw/xtcp8.jpg'),
          text: 'Prefabricated Structure',
        },
      ],
      xtxqList: [
        {
          image: require('@/components/img/cpyfw/cpjs1.jpg'),
          htext: 'Far East Ventilation System',
          ptext:
            'Utilising the thermal energy generated by indoor temperature differences and the wind energy created by natural indoor and outdoor airflow, the system draws fresh air through air inlets on the lower walls of the building and expels internal hot air, exhaust gases, and toxic substances through ventilation outlets, thereby achieving exhaust ventilation. Compared to mechanical ventilation systems, it offers the following advantages: low economic cost, automatic regulation of air exchange volume, quiet operation with no vibration, professional design, and quick and convenient installation.',
        },
        {
          image: require('@/components/img/cpyfw/cpjs2.jpg'),
          htext: 'Far East Roofing System',
          ptext:
            'SD Roofing System:    Utilises specially designed closed sliding fixed brackets with 360° double-layer rolled edge lock seams for airtight connections, offering strong typhoon resistance, excellent thermal insulation, and superior waterproofing performance.\nLD Roofing System:    LD roof panels are connected and fixed using two specially designed brackets in an interlocking and sandwich-style configuration, offering perfect waterproofing, wind and snow resistance, and exceptional load-bearing capacity.\nKD Roofing System:    Utilises specially designed hidden brackets and steel plates connected via an interlocking mechanism, offering strong wind resistance, excellent waterproofing performance, and the ability for steel plates to move during thermal expansion and contraction to prevent damage.\nCD Double-Layer Roofing System:    A screw-through steel plate fixing system, this is a cost-effective roofing system with a unique connection method that effectively resists wind and water leakage.\nVD High-Wave Roofing System:    Features a unique V-shaped wave peak structure with a wave peak height of 176mm, providing high drainage depth. The maximum purlin spacing can reach 3 metres, combined with 360° lock seams and sliding mounting brackets, making it suitable for large-span, wide-purlin-spacing building roofs',
        },
        {
          image: require('@/components/img/cpyfw/cpjs3.jpg'),
          htext: 'Far East Skylight System',
          ptext:
            'Skylight panels are building materials that provide efficient and harmless natural lighting. Their design and structure allow indoor spaces to receive ample natural light, reducing reliance on artificial lighting.\nCompared to traditional lighting equipment, skylight panels do not require electricity, thereby reducing energy consumption and electricity costs. Additionally, the surface coating of skylight panels has certain functional properties. It blocks 99.9% of ultraviolet rays, effectively protecting indoor personnel and items from UV damage. The surface coating also has anti-aging and anti-fading properties, maintaining the appearance and performance of the panels for an extended period and prolonging their service life. Light transmission rate: Transparent (70%); Opaque white (58%).',
        },
        {
          image: require('@/components/img/cpyfw/cpjs4.jpg'),
          htext: 'Substructure System',
          ptext:
            'The substructure system serves as the connecting support for roof panels and wall panels in buildings, typically installed on roof beams and columns. Within this system, purlins are a crucial component, functioning as horizontal support structures connecting roof panels and wall panels.\nPurlin materials are typically high-strength continuous hot-dip galvanised or galvanised-aluminium steel sheets, which offer excellent corrosion resistance, ensuring long-term use even in harsh environments. Additionally, purlins have a smooth and aesthetically pleasing surface, enhancing the visual appeal of roofs and walls.\nThere are two main types of purlins: ‘C’-shaped and ‘Z’-shaped. The ‘C’-shaped purlin has a cross-sectional shape resembling the letter ‘C’ and is typically used to support roof panels. The “Z”-shaped purlin has a cross-sectional shape resembling the letter ‘Z’ and is typically used to support wall panels. These two types of purlins can be selected and installed according to the specific requirements of the building.',
        },
        {
          image: require('@/components/img/cpyfw/cpjs5.jpg'),
          htext: 'Multi-storey systems',
          ptext:
            'Share the same characteristics as low-rise prefabricated steel structures. Compared to traditional reinforced concrete structures, multi-storey steel structures more effectively shorten construction schedules and control construction quality.\nFloor thickness and column dimensions can be minimised, thereby reducing building height, providing more usable space, and saving unnecessary heating and air conditioning supply.\nThe lightweight structure reduces the load on the foundation, thereby saving foundation costs.\nFloors can be constructed on-site using Far East composite floor panels poured with concrete. The floor decking system, which can be constructed quickly under any weather conditions, has been widely recognised by designers for its lightweight design, high strength-to-weight ratio, durability, and aesthetic appeal.',
        },
        {
          image: require('@/components/img/cpyfw/cpjs6.jpg'),
          htext: 'Main Structural System',
          ptext:
            'The main structure consists of steel beams and columns that support the entire steel structure building, fabricated from H-shaped steel through welding. Materials are selected according to engineering design specifications, using national standard Q235B or Q345B steel. Designs are tailored to the specific requirements of each project, offering multiple frame configurations for selection.\nAdvanced automatic welding equipment ensures that weld quality and component quality meet national standards. Imported multi-directional shot blasting equipment is used to ensure thorough rust removal. The surface is coated with anti-corrosion primer to ensure optimal corrosion protection for the steel structure.',
        },
        {
          image: require('@/components/img/cpyfw/cpjs7.jpg'),
          htext: 'Far East Wall Systems',
          ptext:
            'CDII Wall System:    Exposed screws, cost-effective, easy to install, suitable for various types of buildings\nRD Wall System:    Features unique wave peaks with screws partially hidden in the wave grooves, providing a clean and elegant appearance. Economical and easy to install, suitable for various types of buildings.\nPD Wall System:    PD wall panels use interlocking hidden connections with no exposed screws. The 40mm-thick wall space allows for the insertion of thicker insulation materials to enhance thermal performance. \nPU50/MW60 Sandwich System:    The panel surface consists of two layers of coloured steel sheets as the outer panels, offering two core material options: PU50 polyurethane and MW60 rock wool. The core panels feature smooth special low grooves and sawtooth patterns.\nCP Double-Layer Wall Panel System:    Composed of any type of roof panel from Far East and LND inner panels, with a glass wool insulation layer sandwiched between them. The inner panels provide a smooth surface for the roof interior while protecting the roof insulation layer.',
        },
        {
          image: require('@/components/img/cpyfw/cpjs8.jpg'),
          htext: 'Low-rise prefabricated steel structure system',
          ptext:
            'The low-rise prefabricated steel structure system is a modern building system primarily composed of steel materials. It is optimised through advanced design software, manufactured in a factory with high-precision processing, and assembled on-site using connectors, similar to building blocks, without any on-site welding or processing. Features: Short construction period, easy quality control, low maintenance, large usable area, column spacing can be arranged according to production processes, modern aesthetic appearance, and easy to expand. Suitable for factories, logistics warehouses, aircraft hangars, shipyards, and other large-area, long-span buildings across various industries.',
        },
      ],
      jtzlList: [
        {
          image: [require('@/components/img/cpyfw/zlzs1.jpg')],
          text: 'New type V-shaped pull rod',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs2.jpg')],
          text: 'New type of wind-resistant locking plate',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs3.jpg')],
          text: 'Roof ventilation device',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs4.jpg')],
          text: 'Roof metal sheet Installation device',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs5.jpg')],
          text: 'Roof steel plate wind-resistant Structural fixing seat',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs6.jpg')],
          text: 'Manual door opener',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs7.jpg')],
          text: 'Concave-convex embossed steel floor deck',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs8.jpg')],
          text: 'Symmetrical double-stiffened steel bar floor slab',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs9.jpg')],
          text: 'Wind-resistant device for rolling shutter doors',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs10.jpg')],
          text: 'Steel plate sandwich roof',
        },
      ],
      hyxny1: require('@/components/img/cpyfw/xny1.png'),
      hyxny2: require('@/components/img/cpyfw/xny2.png'),
      hyxny3: require('@/components/img/cpyfw/xny3.png'),
      hyxny4: require('@/components/img/cpyfw/xny4.png'),
      hyxny5: require('@/components/img/cpyfw/xny5.png'),
      hyxny6: require('@/components/img/cpyfw/xny6.png'),
      hyxny7: require('@/components/img/cpyfw/xny7.png'),
      hyxny8: require('@/components/img/cpyfw/xny8.png'),
      hyxny9: require('@/components/img/cpyfw/xny9.png'),
      hyxny10: require('@/components/img/cpyfw/xny10.png'),
    }
  },
  methods: {
    // 調用全局方法，滾動指定id
    forId(tId) {
      console.log(tId)
      this.$store.dispatch('toID', tId)
    },

    // 打开模态框
    openModal(index) {
      console.log(index)

      this.selectedIndex = index
      this.isModalOpen = true
      console.log(this.selectedIndex)
    },
    // 关闭模态框
    closeModal() {
      this.isModalOpen = false
    },
    //改变高度
    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth = 1300
        this.cHeight = 700
      } else if (document.body.clientWidth >= 768) {
        this.cWidth = 900
        this.cHeight = 400
      } else if (document.body.clientWidth < 768) {
        this.cWidth = 1000
        this.cHeight = 400
      }
    },
  },
  mounted() {
    // 獲取高度
    window.onresize = () => {
      this.changeHeight()
    }
  },
  created() {
    this.changeHeight()
  },
  updated() {
    if (this.scrollToElement) {
      this.scrollToElement()
      this.scrollToElement = null
    }
  },
}
</script>

<style scoped>
/* 榮譽圖片註釋設置 */
#xtcp .row,
#hyzl .row,
#azfw .row,
#gsxny .row {
  border-top: 1px solid #000;
}
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/cpyfw/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  position: relative;
  width: 100%;
  background-size: 100% 100%;
}

/*-- banner-info --*/
.banner-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.banner-info span {
  font-size: 50px;
  color: #fff;
  padding: 0 10px;
  margin: 0 auto;
  line-height: normal;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
/***** Lexi *****/
/* 小滾輪 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px !important;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #415160;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 10px;
  text-align: center;
  background: #415160;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #2a2f34;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -180px;
}

#ss_menu div:nth-child(2) {
  top: -70px;
  left: -160px;
}

#ss_menu div:nth-child(3) {
  top: -130px;
  left: -130px;
}

#ss_menu div:nth-child(4) {
  top: -160px;
  left: -70px;
}

#ss_menu div:nth-child(5) {
  top: -180px;
  left: 0px;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.hspan,
.hspan2 {
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  font-size: 30px;
  font-weight: 600;
}

.sjzxImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 28vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 15px 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.xtImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 10vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 15px 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.xtImg img,
.sjzxImg img {
  width: 100%;
  height: 100%;
}

.xtp {
  position: absolute;
  top: 50%; /* 父容器高度的50% */
  left: 50%; /* 父容器宽度的50% */
  transform: translate(-50%, -50%); /* 修正自身宽高偏移 */
  background: rgba(128, 128, 128, 0.7); /* 灰色半透明背景 */
  color: white;
  padding: 10px 20px; /* 文字内边距 */
  border-radius: 4px; /* 可选：圆角 */
  text-align: center;
  font-size: 25px;
  width: 40vw;
}

.container-fluid {
  margin: 60px auto;
}

.rzTop {
  margin: 60px 0;
  text-align: center;
}
.azTop {
  margin-bottom: 100px;
  text-align: center;
}
.rzTop h1 {
  margin: 50px 0;
}
.rzTop h1 span {
  padding-bottom: 0px;
  font-size: 34px;
  font-weight: 800;
}
.rzTop p,
.nyTop p {
  margin: 0 auto;
  width: 85vw;
  text-align: left;
  font-size: 20px;
  line-height: 40px;
}

.nyTop {
  margin: 60px 0;
  text-align: center;
}
.nyTop h1 {
  margin: 50px 0;
}
.nyTop h1 span {
  padding-bottom: 0px;
  font-size: 34px;
  font-weight: 800;
}

.zzzsHeight {
  height: 70px;
}
.sjzxHeight {
  height: 70px;
}
.jtzlHeight {
  height: 80px;
}
.hover-content h1 {
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.gradient-background {
  padding: 0 85px 100px;
  border-top: 1px solid #000;
  width: 100%;
  height: 100%; /* 設置高度為視口高度 */
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.mailbg {
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.xtTop {
  margin-top: 60px;
  text-align: center;
}
.xtTop h1 {
  margin-top: 50px;
}
.xtTop h1 span {
  padding-bottom: 0px;
  font-size: 34px;
  font-weight: 800;
}

/* 模态框样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  position: relative;
  background-color: #58585a;
  padding: 70px 0;
  border-radius: 8px;
  max-width: 100vw;
  height: 100vh;
  text-align: center;
}

.xmodaltop {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 40px;
  color: #fff;
  text-align: center;
  width: 90vw;
}

/* 关闭按钮 */
.xclose {
  position: absolute;
  top: 10px;
  right: 25px;
  font-size: 30px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
  opacity: 1;
}

.xxd {
  width: 100vw;
  height: auto;
  max-height: 90%;
}

.xxImg {
  max-width: 100%;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.xxp {
  padding: 5px;
}

.jtzlImg {
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

div /deep/ .jtzlImg img {
  padding: 5px;
  width: 100%;
  overflow: hidden;
  height: 10vw;
  border: 0;
}

/* 新能源 */
.xnytitle {
  font-size: 50px; /*設置文字大小*/
  color: #000; /*設置文字顔色*/
  font-weight: bolder; /*設置文字寬度*/
  text-align: center; /*設置文字居中*/
}
.xnyNum {
  margin: 20px;
  padding: 20px;
  border: 1px solid black;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.xnyContent {
  margin: 10px;
  font-size: 20px;
  max-width: 100%;
}

.xxnrbor {
  padding: 0 100px;
  height: 80vh;
}

div /deep/ .el-carousel__container {
  height: 90vh;
}

div /deep/ .el-carousel__arrow {
  height: 50px;
  width: 50px;
  font-size: 33px;
}

div /deep/ .el-carousel__arrow--right {
  right: 34px;
}

/* 系统 */
.content {
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
  width: 90vw;
  display: flex;
}

.content .img-container {
  float: left;
  margin-right: 20px;
}

.content .img-container img {
  width: 40vw;
  height: 70vh;
}

.content .text-container {
  border: 1px solid #000;
  border-radius: 10px;
  float: right;
  background-color: #fff;
  height: auto;
}
.content .text-container h3 {
  padding: 10px;
  margin: 0;
  text-align: center;
  font-size: 22px;
}
.content .text-container p {
  padding: 15px;
  font-size: 18px;
  line-height: 1.6;
  text-align: left;
}
.content .img-container img {
  border: 3px solid #fff;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
}

/* 指示灯 */
div /deep/.el-carousel__indicators--horizontal {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translate(-50%, 0);
  text-align: center;
}
div /deep/.el-carousel__indicator--horizontal button {
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-radius: 50%;
  opacity: 0.5;
}
div /deep/.el-carousel__indicator--horizontal.is-active button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  opacity: 1;
}

@media screen and (max-width: 1400px) {
  .xxnrbor {
    padding: 0 100px;
    height: 83vh;
  }

  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .nyTop {
    margin: 60px 0 30px;
  }
  .xnyNum {
    margin: 20px 60px;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .container-fluid {
    margin: 15px auto;
  }
  .hspan {
    font-size: 22px;
  }
  .xnytitle {
    font-size: 25px;
  }
  .xnyContent {
    font-size: 19px;
    margin: 0;
  }
  .banner-info p {
    font-size: 28px;
  }
  .rzTop h1 span,
  .xtTop h1 span,
  .nyTop h1 span {
    font-size: 25px;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop p,
  .nyTop p {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 19px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 5px 10px;
  }
  .sjzxImg {
    margin: 5px 0;
  }
  .xtImg {
    margin: 5px 0;
    height: 25vw;
  }
  .xtp {
    padding: 0;
    font-size: 24px;
  }
  .hover-content h1 {
    font-size: 18px;
    margin: 10px 0;
  }
  .jtzlHeight {
    height: 50px;
  }

  div /deep/ .jtzlImg img {
    height: 20vw;
  }
  .rzTop {
    margin: 0;
  }
  .content .text-container img {
    width: 80vw;
    height: 25vw;
  }
  .xxd {
    margin: 0;
  }
  .row {
    padding: 0;
  }
  .content .text-container p {
    padding: 5px;
    font-size: 15px;
    line-height: 1.5;
  }
  .xclose {
    top: 5px;
    right: 5px;
    font-size: 21px;
    width: 30px;
    height: 30px;
  }

  .banner-info span {
    font-size: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 350px;
  }

  div /deep/ .el-carousel__container {
    height: 95vh;
  }
  div /deep/ .el-carousel__arrow {
    height: 40px;
    width: 40px;
    font-size: 25px;
    background-color: rgba(31, 45, 61, 0.5);
  }

  div /deep/ .el-carousel__arrow--right {
    right: 5px;
  }
  div /deep/ .el-carousel__arrow--left {
    left: 5px;
  }

  /* 指示灯 */
  div /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translate(-50%, 0);
    text-align: center;
  }
  div /deep/.el-carousel__indicator--horizontal button {
    width: 10px;
    height: 10px;
  }
  div /deep/.el-carousel__indicator--horizontal.is-active button {
    width: 18px;
    height: 18px;
  }
  .content .text-container {
    height: 83vh;
  }
  .modal-content {
    padding: 45px 0;
  }
  .xmodaltop {
    top: 18px;
    font-size: 26px;
  }
  .azTop {
    margin-bottom: 50px;
    margin-top: 20px;
  }
}

@media screen and (max-width: 768px) {
  .xnyNum {
    margin: 20px 20px;
  }
  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan {
    font-size: 20px;
  }
  .xnytitle {
    font-size: 20px;
  }
  .xnyContent {
    font-size: 13px;
    margin: 0;
  }
  .banner-info p {
    font-size: 28px;
  }
  .rzTop h1 span,
  .xtTop h1 span,
  .nyTop h1 span {
    font-size: 20px;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop p,
  .nyTop p {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }
  .sjzxImg {
    margin: 5px 0;
  }
  .xtImg {
    margin: 5px 0;
    height: 25vw;
  }
  .xtp {
    padding: 0;
    font-size: 13px;
    font-weight: normal;
  }
  .hover-content h1 {
    font-size: 13px;
    margin: 10px 0;
  }
  .jtzlHeight {
    height: 80px;
  }

  div /deep/ .jtzlImg img {
    height: 20vw;
  }
  .rzTop {
    margin: 0;
  }
  .content .text-container img {
    width: 80vw;
    height: 25vw;
  }
  .xxd {
    margin: 0;
  }
  .row {
    padding: 0;
  }
  .content .text-container p {
    padding: 5px;
    font-size: 10px;
    line-height: 1.5;
  }
  .xclose {
    top: 5px;
    right: 5px;
    font-size: 22px;
    width: 30px;
    height: 30px;
  }
  .banner-info {
    width: 90vw;
  }
  .banner-info span {
    font-size: 26px;
  }
  .cbp-spmenu-push .banner {
    height: 200px;
  }

  div /deep/ .el-carousel__container {
    height: 95vh;
  }
  div /deep/ .el-carousel__arrow {
    height: 40px;
    width: 40px;
    font-size: 25px;
    background-color: rgba(31, 45, 61, 0.5);
  }

  div /deep/ .el-carousel__arrow--right {
    right: 5px;
  }
  div /deep/ .el-carousel__arrow--left {
    left: 5px;
  }

  /* 指示灯 */
  div /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translate(-50%, 0);
    text-align: center;
  }
  div /deep/.el-carousel__indicator--horizontal button {
    width: 10px;
    height: 10px;
  }
  div /deep/.el-carousel__indicator--horizontal.is-active button {
    width: 18px;
    height: 18px;
  }
  .content .text-container {
    height: 80vh;
  }
  .modal-content {
    padding: 37px 0;
  }
  .xmodaltop {
    top: 18px;
    font-size: 31px;
  }
  .azTop {
    margin-bottom: 50px;
    margin-top: 20px;
  }
}

@media screen and (min-width: 2000px) {
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .xnyContent {
    margin: 30px;
    font-size: 29px;
    line-height: 1.5;
  }
  .banner-info span {
    font-size: 65px;
  }
  .rzTop h1 span {
    font-size: 40px;
  }
  .rzTop p,
  .nyTop p {
    font-size: 29px;
    line-height: 1.5;
  }
  .xtp {
    font-size: 38px;
  }
  .hover-content h1 {
    font-size: 26px;
    line-height: 1.5;
  }
  .hover-content h1 {
    height: 100px;
  }
  .nyTop h1 span {
    font-size: 40px;
  }
  .content .text-container h3 {
    font-size: 35px;
  }
  .content .text-container p {
    font-size: 25px;
  }
  .jtzlHeight {
    height: 100px;
  }
  .xtTop h1 span {
    font-size: 40px;
  }
}
</style>
